<template>
  <Navbar />
  <ScrollButton />

  <section
    class="banner-title"
    style="background-image: url(images/pcb-device.jpg); background-size: cover; background-position: center;"
  >
    <div class="auto-container">
      <div class="row clearfix">
        <div class="title-column col-md-6 col-sm-6 col-xs-12">
          <h1>Haberler</h1>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12">
          <ul class="bread-crumb clearfix">
            <li><a href="#">Anasayfa</a></li>
            <li class="active">Haberler</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section id="ts-team" class="ts-team" style="background-color: #f8f8f8">
    <div class="container">
      <div class="text-uppercase line-wrapper">
        <div class="line"></div>
        <div class="text">İntek Electronic'den Haberler</div>
        <div class="line"></div>
      </div>

      <div class="row" v-if="displayedNews.length !== 0">
        <div
          class="col-lg-4 col-md-6 col-sm-12 mb-4"
          v-for="news in displayedNews"
          :key="news"
        >
          <div class="team-slide">
            <ul>
              <li>
                <h5><i class="fas fa-calendar-alt calendar"> {{ news.olusturulmaTarihi }} </i></h5>
              </li>
            </ul>
            <div class="ts-team-wrapper ">
              <div class="team-img-wrapper">
                <img
  loading="lazy"
  class="mb-2 rounded"
  :src="news.resim"
  alt="Haber görseli"
/>
              </div>
              <router-link
                :to="{ name: 'NewsDetailById', params: { newsId: news.id } }"
              >
                <div class="ts-team-content">
                  <h3 class="ts-name">{{ news.baslik }}</h3>
                  <p class="ts-designation">{{ news.altbaslik }}</p>
                  <p class="ts-description truncate">{{ news.icerik }}</p>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="pagination">
        <button @click="prevPage" v-if="currentPage > 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>
        <button
          v-for="pageNumber in totalPages"
          :key="pageNumber"
          @click="goToPage(pageNumber)"
          :class="{ active: currentPage === pageNumber }"
        >
          {{ pageNumber }}
        </button>
        <button @click="nextPage" v-if="currentPage < totalPages">
          <i class="bi bi-chevron-double-right"></i>
        </button>
      </div>
    </div>
  </section>

  <Footer />
</template>

<script>
import Navbar from "@/components/Navbar-2.vue";
import ScrollButton from "@/components/ScrollButton.vue";
import Footer from "@/components/Footer.vue";
import { ref, onMounted, computed } from "vue";
import { firestore } from "@/firebase/config";
import moment from "moment";
import {
  query,
  collection,
  orderBy,
  limit,
  getDocs,
  where
} from "firebase/firestore";

export default {
  components: {
    Navbar,
    ScrollButton,
    Footer
  },
  setup() {
    const newsList = ref([]);
    const isLoading = ref(true);
    const currentPage = ref(1);
    const pageSize = 3;
    const totalItems = ref(0);

    const totalPages = computed(() => Math.ceil(totalItems.value / pageSize));

    const displayedNews = computed(() => {
      const startIndex = (currentPage.value - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      return newsList.value.slice(startIndex, endIndex);
    });

    const goToPage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
      }
    };

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value++;
      }
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--;
      }
    };

    onMounted(async () => {
      const q = query(
        collection(firestore, "haberler"),
        where("durum", "==", true),
        orderBy("olusturulmaTarihi", "desc"),
        limit(20)
      );

      const querySnapshot = await getDocs(q);
      const veri = [];

      querySnapshot.forEach((doc) => {
        veri.push({ ...doc.data(), id: doc.id });
      });

      newsList.value = veri.map((item) => ({
        ...item,
        olusturulmaTarihi: moment(item.olusturulmaTarihi.toDate()).format("DD.MM.YYYY")
      }));

      totalItems.value = veri.length;
      isLoading.value = false;
    });

    return {
      newsList,
      isLoading,
      currentPage,
      totalPages,
      goToPage,
      displayedNews,
      prevPage,
      nextPage
    };
  }
};
</script>

<style scoped>
ul {
  list-style: none;
  padding: 0;
}
.line-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 2rem 0;
}
.line {
  flex: 1;
  height: 1px;
  background: #ccc;
}
.text {
  font-weight: bold;
  color: #0152c9;
  text-transform: uppercase;
}
.calendar {
  color: #0152c9;
  font-style: normal;
}
.ts-team-wrapper {
  background: white;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
}
.team-img-wrapper img {
  width: 100%;
  object-fit: cover;
  display: block;
  border-radius: 10px;
  height: 250px;
}

.ts-team-wrapper:hover {
  transform: translateY(-5px);
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
  gap: 0.5rem;
}
.pagination button {
  border: none;
  background: #eee;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}
.pagination button.active,
.pagination button:hover {
  background: #145da0;
  color: white;
}

@media (max-width: 768px) {
  .ts-team-wrapper{
height: 320px;
  }
  .team-img-wrapper img {
    height: 290px !important;
  }
  .text{
    line-height: 50px;
  }
    
}
</style>